import { Route, Routes } from 'react-router-dom';
import { Agenda, FAQ, Home, Partners, Press, VentureNurturing, Register, Speakers, Startups, Venue, Volunteer, } from './pages';
import { Footer, NavBar, Schedule, Tickets } from './components';
import { useScrollToTop } from './hooks/useScrollToTop';

function App() {
   useScrollToTop()
   return (
      <div className="App">
         <NavBar />
         <Routes>
            <Route path='/' element={<Home />} />
            <Route path='startups' element={<Startups />} />
            <Route path='speakers' element={<Speakers />} />
            <Route path='partners' element={<Partners />} />
            <Route path='venue' element={<Venue />} />
            <Route path='volunteer' element={<Volunteer />} />
            <Route path='press' element={<Press />} />
            <Route path='venture-nurturing' element={<VentureNurturing />} />
            <Route path='faq' element={<FAQ />} />
            <Route path='agenda/*' element={<Agenda />} >
               <Route path=':day' element={<Schedule />} />
            </Route>
            <Route path='registration/*' element={<Register />}>
               <Route path=':type' element={<Tickets />} />
            </Route>
            <Route path='*' element={<div>Not found</div >} />
         </Routes>
         <Footer />
      </div >
   );
}

export default App;
